import types from './types'

export default {
  [types.SET_MODAL_DATA] (state, modalData = []) {
    state.modalData = modalData
  },
}
